import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../utils/navigationRoutes";

export const useBackNavigation = () => {
  const navigate = useNavigate();

  const goBack = (fallbackRoute?: string) => {
    // Check if we have history to go back to
    if (window.history.length > 1) {
      navigate(-1);
    } else if (fallbackRoute) {
      // Fallback to specific route
      navigate(fallbackRoute);
    } else {
      // Default fallback to home page
      navigate("/glucera" + GluceraNavigationRoutes.HOME);
    }
  };

  return { goBack };
};
